import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section background="warm" className="py-24" data-id="element-43">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-44">
        <FadeIn data-id="element-45">
          <span className="text-accent-500 text-xs font-bold uppercase tracking-[0.25em] block mb-4" data-id="element-46">
            Exclusive & Confidential
          </span>
          <h2 className="text-3xl md:text-5xl font-serif text-ink-900 mb-6 leading-tight" data-id="element-47">
            The Next Chapter of Your Legacy Starts Here
          </h2>
          <div className="h-[2px] w-16 bg-accent-400 mb-6" data-id="element-48" />
          <p className="text-lg text-body mb-12 font-light leading-relaxed" data-id="element-49">
            At the executive level, opportunity doesn't wait — and neither
            should you. Share your details below, and a senior advisor will
            reach out within 24 hours to discuss your career trajectory in
            complete confidence.
          </p>

          <form className="space-y-6 bg-white p-8 rounded-sm shadow-sm border border-sage-200" data-id="element-50">
            <div data-id="element-51">
              <label htmlFor="name" className="block text-sm font-medium text-ink-700 mb-1" data-id="element-52">
                Full Name
              </label>
              <input type="text" id="name" placeholder="Ian Deo" className="w-full px-4 py-3 border border-sage-300 focus:border-accent-400 focus:ring-1 focus:ring-accent-400 outline-none transition-colors bg-sage-50" data-id="element-53" />
            </div>
            <div data-id="element-54">
              <label htmlFor="email" className="block text-sm font-medium text-ink-700 mb-1" data-id="element-55">
                Email Address
              </label>
              <input type="email" id="email" placeholder="ian@example.com" className="w-full px-4 py-3 border border-sage-300 focus:border-accent-400 focus:ring-1 focus:ring-accent-400 outline-none transition-colors bg-sage-50" data-id="element-56" />
            </div>
            <div data-id="element-57">
              <label htmlFor="phone" className="block text-sm font-medium text-ink-700 mb-1" data-id="element-58">
                Phone Number
              </label>
              <input type="tel" id="phone" placeholder="(555) 123-4567" className="w-full px-4 py-3 border border-sage-300 focus:border-accent-400 focus:ring-1 focus:ring-accent-400 outline-none transition-colors bg-sage-50" data-id="element-59" />
            </div>
            <div data-id="element-60">
              <label htmlFor="title" className="block text-sm font-medium text-ink-700 mb-1" data-id="element-61">
                Current Title
              </label>
              <input type="text" id="title" placeholder="VP of Operations" className="w-full px-4 py-3 border border-sage-300 focus:border-accent-400 focus:ring-1 focus:ring-accent-400 outline-none transition-colors bg-sage-50" data-id="element-62" />
            </div>
            <div data-id="element-63">
              <label htmlFor="message" className="block text-sm font-medium text-ink-700 mb-1" data-id="element-64">
                Message
              </label>
              <textarea id="message" rows={4} placeholder="How can we assist you?" className="w-full px-4 py-3 border border-sage-300 focus:border-accent-400 focus:ring-1 focus:ring-accent-400 outline-none transition-colors bg-sage-50" data-id="element-65"></textarea>
            </div>
            <Button variant="primary" size="lg" className="w-full" data-id="element-66">
              Schedule a Consultation
            </Button>
          </form>
        </FadeIn>

        <FadeIn delay={0.2} className="lg:pt-24 space-y-12" data-id="element-67">
          <div data-id="element-68">
            <h3 className="text-sm font-bold uppercase tracking-widest text-ink-900 mb-2" data-id="element-69">
              Email Us
            </h3>
            <a href="mailto:thayerdraven@pinnacletalentadvisor.com" className="text-lg text-accent-500 hover:text-accent-600 transition-colors" data-id="element-70">
              thayerdraven@pinnacletalentadvisor.com
            </a>
          </div>

          <div data-id="element-71">
            <h3 className="text-sm font-bold uppercase tracking-widest text-ink-900 mb-2" data-id="element-72">
              Call Us
            </h3>
            <a href="tel:9202874364" className="text-lg text-body hover:text-ink-900 transition-colors" data-id="element-73">
              (920) 287-4364
            </a>
          </div>

          <div data-id="element-74">
            <h3 className="text-sm font-bold uppercase tracking-widest text-ink-900 mb-2" data-id="element-75">
              Office Hours
            </h3>
            <p className="text-lg text-body" data-id="element-76">
              Monday – Friday, 8:00 AM – 6:00 PM CST
            </p>
          </div>

          <div className="relative p-6 bg-ink-900 border border-accent-400/20 overflow-hidden" data-id="element-77">
            <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-accent-400 to-transparent" data-id="element-78" />
            <div className="absolute top-3 left-3 w-5 h-5 border-t border-l border-accent-400/30" data-id="element-79" />
            <div className="absolute top-3 right-3 w-5 h-5 border-t border-r border-accent-400/30" data-id="element-80" />
            <div className="absolute bottom-3 left-3 w-5 h-5 border-b border-l border-accent-400/30" data-id="element-81" />
            <div className="absolute bottom-3 right-3 w-5 h-5 border-b border-r border-accent-400/30" data-id="element-82" />
            <p className="text-sage-200 font-serif italic text-base leading-relaxed text-center" data-id="element-83">
              Consultations available in person, by phone, or via secure video
              conference.
            </p>
            <div className="flex items-center justify-center gap-4 mt-4" data-id="element-84">
              <div className="h-[1px] w-8 bg-accent-400/40" data-id="element-85" />
              <span className="text-accent-400 text-[10px] font-bold uppercase tracking-[0.2em]" data-id="element-86">
                Your Privacy, Our Priority
              </span>
              <div className="h-[1px] w-8 bg-accent-400/40" data-id="element-87" />
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
}